import { render, staticRenderFns } from "./Attributions.vue?vue&type=template&id=7ec809d5&scoped=true"
import script from "./Attributions.vue?vue&type=script&lang=js"
export * from "./Attributions.vue?vue&type=script&lang=js"
import style0 from "./Attributions.vue?vue&type=style&index=0&id=7ec809d5&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec809d5",
  null
  
)

export default component.exports